<template>
  <div class="pros">
    <div class="title">
      <div class="a-t">志愿服务 <span>/ volunteer service</span></div>
    </div>
    <div class="content">
      <a-spin v-if="loading" tip="Loading..."><div class="spin-content"></div></a-spin>
      <ul class="clearfix">
        <li class="vol-item" v-for="(act, index) in proList" :key="'act' + index">
          <div class="pic"><img v-if="act.bgUrl" :src="act.bgUrl[0]"/></div>
          <div class="text">
            <div class="d-t">{{act.name}}</div>
            <div class="d-c">
              活动时间：{{act.time}}<br/>
              地址：{{act.address}}
            </div>
            <div class="opt">
              <template v-if="act.status != '0' && parseInt(act.hasnews) <= 0">
                <i :pId="act.id" type="1" @click="toDetail">查看详情<a-icon type="caret-right" /></i>
              </template>
              <template v-if="act.status != '0' && parseInt(act.hasnews) > 0">
                <i :pId="act.id" type="2" @click="toDetail">查看详情<a-icon type="caret-right" /></i>
              </template>
            </div>
          </div>
        </li>
      </ul>
      <div class="con-empty" v-if="isEmpty"><img src="../../assets/empty.png"/><br/><br/>暂时无数据…</div>
      <div class="paging">
        <a-pagination :pageSizeOptions="['9','18','27']" showSizeChanger :pageSize.sync="pageSize" @change="pageChange" @showSizeChange="onShowSizeChange" :total="total" v-model="current"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'volunt',
  data () {
    return {
      loading: true,
      proList: [],
      current: 1,
      pageNo: 1,
      pageSize: 9,
      total: 0,
      tip: "",
      isEmpty: false
    }
  },
  components: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      this.getList();
    },
    getList () {
      this.loading = true;
      this.proList = [];
      this.isEmpty = false;
      this.$store.dispatch('ajaxProList', {
        pageIndex: this.pageNo,
				pageSize: this.pageSize,
				name: "活动",
				tip: this.tip
      }).then((data) => {
        this.total = data;
        this.proList = this.$store.state.Project.proList;
        this.loading = false;
        if(this.proList.length <= 0){
          this.isEmpty = true;
        }
      })
    },
    pageChange (page) {
      this.pageNo = page;
      this.getList();
    },
    onShowSizeChange() {
      this.getList();
    },
    toDetail (event) {
      var item = event.currentTarget,
          pId = item.getAttribute('pId'),
          type = item.getAttribute('type');
      this.$router.push({ path: "vol/" + pId, query: {type: type}});
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/volunt';
</style>
